const Loading = () => {
  return (
    <div className="loading">
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
  );
};

export default Loading;
